function KirkleesCareAssessmentCalculator(
  constants,
  CarephoneAssessmentInputModel,
  FullAssessmentInputModel,
  numberUtils,
  RespiteCareType,
  NonResidentialCareType,
  CarephoneCareType,
  Week1ResidentialCareType,
  Week5ResidentialCareType,
  Week13ResidentialCareType,
  sfSelect,
  formModelService,
  careAssessmentService,
  calculationResultService
) {

      var WORKBOOK_CONSTANTS = {
        NOT_DISCLOSED: "Not disclosed",
        EARNINGS_OVER_MIG: "Earnings over MIG"
      };

      var userInputModel,
        careTypeStrategy,
        workings = {user: {}, partner: {}},
        userTypes = constants.userTypes;

      function capitalTariff(userType, individualCapital, jointCapital) {

        console.log("Calculating capital tariff having user type", userType, ", individual capital", individualCapital, ", joint capital", jointCapital);

        var indCapital = individualCapital + (0.5 * jointCapital);
        console.log("Total individual capital", indCapital);

        var capitalDisregard = constants.capitalDisregard[userType];
        console.log("Capital disregard", capitalDisregard);

        var threshold = constants.capitalDisregard.threshold;
        console.log("Capital disregard threshold", threshold);

        var capitalTariffPartial = indCapital > capitalDisregard ? Math.ceil((indCapital - capitalDisregard) / 250) : 0;
        console.log("Capital tariff (partial)", capitalTariffPartial);

        var result = capitalTariffPartial > threshold ? constants.fullCost : capitalTariffPartial;
        console.log("Capital tariff", result);

        workings[userType].capitalTariff = result;
        workings[userType].totalCapital = indCapital;
      }

      function getPersonalData(userType) {
        return userType === userTypes.user ? userInputModel.getApplicantData() : userInputModel.getPartnerData();
      }

      function grossWeeklyIncome(userType) {
        var personalData = getPersonalData(userType);

        // The partner's attendance allowance should be excluded from their gross income. We need to know the *level*
        // of AA the partner is receiving so we can determine in the PLA calculation whether they are disabled or not.
        //
        // The partner's mobility allowance is also excluded from their gross income, and is not currently used
        // anywhere in the calculation. It could be omitted from the form completely, but it was decided to
        // retain it just in case it's needed in the future.
        var incomeSourcesClone = angular.copy(personalData.incomes);

        if (userType === userTypes.partner && angular.isObject(incomeSourcesClone)) {
          _.remove(incomeSourcesClone, function (incomeSource) {
            return ['attendanceAllowance', 'mobilityAllowance'].indexOf(incomeSource.name) > -1;
          });
        }

        var total = incomeSourcesClone.reduce(function (runningTotal, incomeSource) {
          return runningTotal + incomeSource.weeklyAmount;
        }, 0);
        console.log("Sum of weekly income sources", total);

        var applicantData = userInputModel.getApplicantData();
        var weeklyUniversalCreditIncome = applicantData.getWeeklyIncome('universalCredit');
        var weeklyWorkingTaxCreditIncome = userInputModel.getWeeklyWorkingTaxCredit();
        var allowableWorkingTaxCredit = careTypeStrategy.getAllowableWorkingTaxCredit(weeklyWorkingTaxCreditIncome);
        console.log('Allowable working tax credit:', allowableWorkingTaxCredit);
        total += allowableWorkingTaxCredit;

        if (userInputModel.isCouple()) {

          // allocate half the pension credits and universal credit to the applicant and the other half to their partner
          var halfPensionCreditTotal = (applicantData.getWeeklyIncome('pensionGuaranteeCredit') +
            applicantData.getWeeklyIncome('pensionSavingsCredit')) / 2;
          var halfUniversalCreditTotal = weeklyUniversalCreditIncome / 2;

          if (userType === userTypes.user) {
            total -= (halfPensionCreditTotal + halfUniversalCreditTotal);
          } else {
            total += (halfPensionCreditTotal + halfUniversalCreditTotal);
          }

          // KERP-2458 if JSA/ESA is paid as a couple, allocate half of the user's JSA/ESA total to their partner
          if (userInputModel.isBenefitPaidAsCouple()) {
            var allowancesAdjustments = applicantData.getWeeklyIncome('incapacityBenefit') / 2;

            if (userType === userTypes.user) {
              allowancesAdjustments *= -1;
            }

            total += allowancesAdjustments;
            console.log('JSA + ESA total adjusted by', allowancesAdjustments, 'for', userType);
          }
        }

        if (userType === userTypes.user) {
          var capitalTariff = workings[userType].capitalTariff;
          if (numberUtils.isNumeric(capitalTariff)) {
            total += capitalTariff;
          }
        }

        console.log("Gross weekly income for", userType, total);
        workings[userType].grossIncome = total;
        workings.universalCreditIncome = weeklyUniversalCreditIncome;
      }

      function disregardedIncome(userType) {

        var disregards = {};
        var personalData = getPersonalData(userType);

        if (personalData.incomes) {
          disregards.pensionSavingsCredit = careTypeStrategy.getDisregardedPensionSavingsCredit(userType, workings);
          console.log("Disregard pension savings credit", disregards.pensionSavingsCredit);

          disregards.childBenefit = personalData.getWeeklyIncome('childBenefit');
          disregards.warDisablementPension = personalData.getWeeklyIncome('warDisablementPension');

          if (userType === userTypes.user) {
            disregards.warPension = Math.min(10, personalData.getWeeklyIncome('warPension'));
            disregards.attendanceAllowance = careTypeStrategy.getDisregardedAttendanceAllowance();
            disregards.privatePension = careTypeStrategy.getDisregardedPrivatePension();
            disregards.mobilityAllowance = personalData.getWeeklyIncome('mobilityAllowance');
            disregards.warSpecialPayment = Math.min(personalData.getWeeklyIncome('warSpecialPayment'), constants.warSpecialPaymentDisregard);
            disregards.carersPremium = careTypeStrategy.getDisregardedCarersPremium(personalData.isEntitledToCarersPremium, personalData.getWeeklyIncome('carersAllowance'));
            disregards.childrensPremium = careTypeStrategy.getChildrensPremium();
          }

          var weeklyEmploymentIncome = personalData.getWeeklyIncome('earningsFromPaidEmployment');

          disregards.earningsFromPaidEmployment = userType === userTypes.user ? weeklyEmploymentIncome
            : weeklyEmploymentIncome * constants.partnersEarningsDisregarded;

          console.log("Disregard earnings from paid employment", disregards.earningsFromPaidEmployment);
        }

        var totalDisregards = -1 * numberUtils.sumPropertyValues(disregards);
        console.log("Total disregards", totalDisregards);
        workings[userType].pscDisregard = disregards.pensionSavingsCredit;
        workings[userType].disregards = totalDisregards;
      }

      function totalCosts() {
        var totalHouseholdCosts = -1 * careTypeStrategy.getTotalWeeklyExpenses();

        var contributors = userInputModel.isCouple() ? 2 : 1;
        console.log("Expenses total:", totalHouseholdCosts, "Contributors:", contributors);
        var totalCostsPerUser = totalHouseholdCosts / contributors;
        workings.totalCosts = totalCostsPerUser;
        console.log("Total costs (per user)", totalCostsPerUser);
      }

      function userAgeIncomeExpenditure(userType) {
        var personalData = getPersonalData(userType) || {};

        var ageLevelResults = careAssessmentService.getAgeLevel(personalData.dob, constants.levels);
        workings[userType].ageLevel = ageLevelResults.level;
        workings[userType].ageLevelLabel = ageLevelResults.label;

        capitalTariff(userType, personalData.individualCapital, userInputModel.getJointCapital());
        grossWeeklyIncome(userType);
        disregardedIncome(userType);
      }

      function netIncome(userType) {

        var result = workings[userType].grossIncome + workings[userType].disregards;
        console.log("Sum gross income", workings[userType].grossIncome, "and disregards", workings[userType].disregards);

        if (userType === userTypes.user) {
          console.log("Add total costs", workings.totalCosts);
          result += workings.totalCosts;
          result -= userInputModel.getWeeklyExpense('compulsoryPayments');
        }

        console.log("Net income for", userType, result);
        workings[userType].netIncome = result;
      }

      function partnersMIGShortfall() {
        var partnerMinimumIncomeGuarantee = careTypeStrategy.getPartnerMinimumIncomeGuarantee(workings);
        console.log("Partner MIG table lookup", partnerMinimumIncomeGuarantee);

        var partnerIncome = workings[userTypes.partner].netIncome;
        var partnerResult;

        if (workings[userTypes.partner].grossIncome === 0 || !userInputModel.isParterFinanceDeclared()) {
          partnerResult = WORKBOOK_CONSTANTS.NOT_DISCLOSED;

        } else if (partnerIncome > partnerMinimumIncomeGuarantee) {
          partnerResult = WORKBOOK_CONSTANTS.EARNINGS_OVER_MIG;

        } else {
          partnerResult = partnerIncome - partnerMinimumIncomeGuarantee;
        }

        var userResult = partnerResult === WORKBOOK_CONSTANTS.EARNINGS_OVER_MIG ? 0 : partnerResult;
        console.log('MIG shortfall for', userTypes.user, userResult);
        workings[userTypes.user].migShortfall = isNaN(userResult) ? 0 : userResult;

        console.log('MIG shortfall for', userTypes.partner, partnerResult);
        workings[userTypes.partner].migShortfall = isNaN(partnerResult) ? 0 : partnerResult;
      }

      function totalIncome(userType) {

        var result = workings[userType].netIncome;

        if (userType === userTypes.partner) {

          if (!userInputModel.isParterFinanceDeclared()) {
            result = WORKBOOK_CONSTANTS.NOT_DISCLOSED;

          } else if (workings[userType].grossIncome === 0) {
            result = 0;
          }
        }

        console.log('Total income for', userType, result);
        workings[userType].totalIncome = result;
      }

      function careContribution(costOfCare) {
        var userResults = workings.user;
        var weeklyDisposableIncome;
        var contributionUpperBound;
        var contributions = {
          maxContribution: undefined,
          actualContribution: undefined
        };

        if (userResults.capitalTariff === constants.fullCost) {
          weeklyDisposableIncome = constants.fullCost;
          contributionUpperBound = constants.maxWeeklyContribution;
        } else {
          weeklyDisposableIncome = userResults.totalIncome + userResults.totalPLA;
          weeklyDisposableIncome += numberUtils.isNumeric(userResults.migShortfall) ? userResults.migShortfall : 0;

          contributionUpperBound = Math.min(constants.maxWeeklyContribution, weeklyDisposableIncome);
          contributionUpperBound = careTypeStrategy.adjustContribution(contributionUpperBound, workings);
          contributionUpperBound = Math.max(contributionUpperBound, 0);
          contributionUpperBound = numberUtils.roundNearest(contributionUpperBound);
        }

        console.log('Weekly disposable income', weeklyDisposableIncome);
        console.log('Contribution upper bound', contributionUpperBound);

        if (numberUtils.isNumeric(costOfCare)) {
          if (contributionUpperBound >= constants.maxWeeklyContribution) {
            contributions.actualContribution = costOfCare;
          } else {
            contributions.actualContribution = Math.min(costOfCare, contributionUpperBound);
          }
          console.log('Actual contribution', contributions.actualContribution);
        }

        if (contributionUpperBound < constants.maxWeeklyContribution) {
          contributions.maxContribution = contributionUpperBound;
          console.log('Max contribution', contributions.maxContribution);
        } else {
          console.log('Max contribution is (full cost)', constants.maxWeeklyContribution);
        }

        return {
          workings: getBreakdown(),
          contributions: contributions
        };
      }

      function getBreakdown() {
        var userType = constants.userTypes.user;
        var partnerType = constants.userTypes.partner;

        return {
          totalCosts: numberUtils.numberToString(workings.totalCosts, Math.abs),
          ageLevel: workings[userType].ageLevelLabel || '',
          capitalTariff: numberUtils.numberToString(workings[userType].capitalTariff, Math.abs),
          totalCapital: numberUtils.numberToString(workings[userType].totalCapital, Math.abs),
          grossIncome: numberUtils.numberToString(workings[userType].grossIncome, Math.abs),
          disregards: numberUtils.numberToString(workings[userType].disregards, Math.abs),
          netIncome: numberUtils.numberToString(workings[userType].netIncome, function (number) {
            return number < 0 ? 0 : number;
          }),
          personalLivingAllowance: numberUtils.numberToString(workings[userType].totalPLA, Math.abs),
          partnerMIG: numberUtils.numberToString(workings[partnerType].migShortfall, Math.abs),
          universalCreditIncome: numberUtils.numberToString(workings.universalCreditIncome, Math.abs)
        };
      }

      function saveCalcResults(careType, calcResults, model) {
        calculationResultService.saveCalcResults(careType, calcResults, model);
      }

      this.recalculate = function (dirtyModel, cleanModel, isShortForm, careType) {

        var recalculateCareTypes = careType ? [careType] : Object.keys(constants.careTypes);
        var self = this;

        recalculateCareTypes.forEach(function (careType) {
          var calcResults = self.calculate(cleanModel, isShortForm, careType);

          saveCalcResults(careType, calcResults, dirtyModel);
          saveCalcResults(careType, calcResults, cleanModel);
        });
      };

      this.calculate = function (fields, isShortForm, careType) {

        var careTypes = constants.careTypes;

        userInputModel = isShortForm ? new CarephoneAssessmentInputModel(fields) : new FullAssessmentInputModel(fields);

        switch (careType) {
          case careTypes.respite:
            careTypeStrategy = new RespiteCareType(userInputModel);
            break;
          case careTypes.nonResidential:
            careTypeStrategy = new NonResidentialCareType(userInputModel);
            break;
          case careTypes.carephone:
            careTypeStrategy = new CarephoneCareType(userInputModel);
            break;
          case careTypes.week1Residential:
            careTypeStrategy = new Week1ResidentialCareType(userInputModel);
            break;
          case careTypes.week5Residential:
            careTypeStrategy = new Week5ResidentialCareType(userInputModel);
            break;
          case careTypes.week13Residential:
            careTypeStrategy = new Week13ResidentialCareType(userInputModel);
            break;
          default:
            throw new Error("Unknown care type:" + careType);
        }

        if (userInputModel.isValid()) {
          var hasPartner = userInputModel.isCouple();
          userAgeIncomeExpenditure(userTypes.user);

          if (hasPartner) {
            userAgeIncomeExpenditure(userTypes.partner);
          }

          totalCosts();
          netIncome(userTypes.user);

          if (hasPartner) {
            netIncome(userTypes.partner);
            partnersMIGShortfall();
          }

          totalIncome(userTypes.user);
          if (hasPartner) {
            totalIncome(userTypes.partner);
          }

          careTypeStrategy.personalLivingAllowance(workings);

          const calcResults = careContribution(userInputModel.getCostOfCare(careType));

          if (((fields || {}).declaration || {}).provideFinancialDetails !== 'agree') {
            calcResults.contributions.maxContribution = undefined;
            console.log('Max contribution is (full cost) - calculation not considered');
          }

          return calcResults;
        }
      };
}

KirkleesCareAssessmentCalculator.$inject = [
  'kirkleesCareAssessmentConstants',
  'CarephoneAssessmentInputModel',
  'FullAssessmentInputModel',
  'numberUtils',
  'RespiteCareType',
  'NonResidentialCareType',
  'CarephoneCareType',
  'Week1ResidentialCareType',
  'Week5ResidentialCareType',
  'Week13ResidentialCareType',
  'sfSelect',
  'formModelService',
  'careAssessmentService',
  'calculationResultService'
];

angular.module('kerp-forms.forms').service('kirkleesCareAssessmentCalculator', KirkleesCareAssessmentCalculator);
